export default {
  formatDate: (timestamp) => {
    let formattedDate

    if (typeof timestamp === 'number') {
      let date = new Date(timestamp)
      formattedDate = date.getHours() + ':' +
      date.getMinutes() + ':' +
      date.getSeconds() + ' ' +
      date.getMilliseconds() + 'ms'
    }

    return formattedDate
  },
  formatTime: (milliseconds) => {
    let time

    if (milliseconds === 'N/A') {
      time = milliseconds
    } else if (milliseconds < 1000) {
      time = `${milliseconds}ms`
    } else {
      time = `${(milliseconds / 1000).toFixed(2)}s`
    }

    return time
  },
}



// WEBPACK FOOTER //
// ./src/app/filters/timestamps.js